export default function Toolbar({
  search,
  onSearchChange,
  sortKey,
  sortDir,
  onSortChange,
  viewMode,
  onViewModeChange,
  onNewFolder,
  onUploadClick,
  onTrashClick,
}) {
  return (
    <div className="fm-toolbar">
      <input
        className="fm-search"
        type="text"
        placeholder="Search this folder…"
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
      />

      <select
        className="fm-sort"
        value={`${sortKey}-${sortDir}`}
        onChange={(e) => {
          const [key, dir] = e.target.value.split("-");
          onSortChange(key, dir);
        }}
        title="Sort by"
      >
        <option value="name-asc">Name (A to Z)</option>
        <option value="name-desc">Name (Z to A)</option>
        <option value="modified-desc">Newest first</option>
        <option value="modified-asc">Oldest first</option>
        <option value="size-desc">Largest first</option>
        <option value="size-asc">Smallest first</option>
      </select>

      <div className="fm-view-toggle" role="group" aria-label="View mode">
        <button
          className={viewMode === "list" ? "active" : ""}
          onClick={() => onViewModeChange("list")}
          title="List view"
        >
          ☰
        </button>
        <button
          className={viewMode === "grid" ? "active" : ""}
          onClick={() => onViewModeChange("grid")}
          title="Grid view"
        >
          ▦
        </button>
      </div>

      <button className="fm-btn" onClick={onUploadClick}>
        ⬆️ Upload
      </button>
      <button className="fm-btn fm-btn-ghost" onClick={onNewFolder}>
        ➕ New Folder
      </button>
      <button className="fm-btn fm-btn-quiet" onClick={onTrashClick} title="Deleted files">
        🗑️ Trash
      </button>
    </div>
  );
}
